import React from 'react';
import BaseSelect from '../base-select';
import CustomOption from './components/custom-option';
import { SIZES } from '../base-select/constants';
import noop from '../../../utils/noop';
const IconSelect = ({
  options,
  size = SIZES.small,
  invalid = false,
  disabled = false,
  onChange = noop,
  defaultValue = undefined,
}) => (
  <BaseSelect
    className="ws-ui-icon-select"
    clearable={false}
    onChange={onChange}
    options={options}
    components={{ Option: CustomOption, SingleValue: CustomOption }}
    size={size}
    defaultValue={defaultValue}
    invalid={invalid}
    disabled={disabled}
  />
);

export default IconSelect;
